import { InputHTMLAttributes, ReactNode } from 'react'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string
  error?: string
  children?: ReactNode // optional prefix control (e.g. country picker)
}

export default function TextField({ label, error, required, id, children, className, ...input }: Props) {
  const inputId = id ?? input.name
  return (
    <div className={`ho-field ${className ?? ''}`}>
      <label className="ho-label" htmlFor={inputId}>
        {label}
        {required && <span className="ho-req" aria-hidden="true">*</span>}
      </label>
      <div className="ho-control" aria-invalid={!!error}>
        {children}
        <input id={inputId} required={required} aria-invalid={!!error} aria-describedby={error ? `${inputId}-error` : undefined} {...input} />
      </div>
      {error && <p className="ho-error" id={`${inputId}-error`}>{error}</p>}
    </div>
  )
}
